import { Table } from "semantic-ui-react";
import { PermitBlueprint } from "../models/PermitBlueprint";
import GridActionButton from "./GridActionButton";

interface Props {
  blueprints?: PermitBlueprint[];
  onEditBlueprint: (blueprintId: string) => void;
  onAddToOrganization: (blueprintId: string) => void;
}

const PermitBlueprintsGrid = ({ blueprints, onEditBlueprint, onAddToOrganization }: Props) => {
  const renderRows = () => {
    if (blueprints) {
      return blueprints.map((blueprint) => (
        <Table.Row key={blueprint.id}>
          <Table.Cell>
            {blueprint.name}
            <GridActionButton
              rowId={blueprint.id}
              items={[
                { key: "edit", icon: "edit", content: "Edit", callback: onEditBlueprint },
                {
                  key: "add-to-org",
                  icon: "building",
                  content: "Add to Organization",
                  callback: onAddToOrganization,
                },
              ]}
            />
          </Table.Cell>
          <Table.Cell>{blueprint.template?.fields?.length ?? 0}</Table.Cell>
        </Table.Row>
      ));
    }
  };

  return (
    <Table basic="very" compact>
      <Table.Header>
        <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Fields</Table.HeaderCell>
          </Table.Row>
      </Table.Header>
      <Table.Body>{renderRows()}</Table.Body>
      <Table.Footer>
        <Table.Row textAlign="right">
          <Table.HeaderCell colSpan="2"></Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default PermitBlueprintsGrid;




